import { UserRoles } from "./UserRoles";

const canViewOrganisationSettingsTabs = [
    UserRoles.ROLE_APPLICATION_MANAGERS,
    UserRoles.ROLE_CLIENT_CENTER,
    UserRoles.ROLE_BEDRIJFSBUREAU,
    UserRoles.ROLE_CLIENT_ADMIN,
    UserRoles.ROLE_CONSULTANTS,
];

export default canViewOrganisationSettingsTabs;
